  <div class="ibox ">
    <iboxtools *ngIf="horario != null"
               [Title]=""
               [isHistory]=true
               [DateInit]="horario?.desde"
               [DateEnd]="horario?.hasta"
               [PeriodList]="horariosHistoryList"
               [IsEditing]="isEditing"
               (PeriodChange)="OnPeriodChange($event)"
               (NewChange)="OnNewChange($event)"
               (EditChange)="OnEditChange($event)"
               (SaveChange)="OnSaveChange($event)"
               (CutChange)="OnCutChange($event)"
               (DeleteChange)="OnDeleteChange($event)"
               (CancelChange)="OnCancelChange($event)"
               [Permiso]="permisoEdicion">
    </iboxtools>
    <div class="ibox-content" *ngIf="horario != null">
      <mat-error *ngIf="horariosInvalida" class="horariosInvalida">{{MensajeError}}</mat-error>
      <form [formGroup]="form">
        <div class="row" hidden="true">
          <input formControlName="id" name="id" type="text" class="form-control" />
          <input formControlName="personal" name="personal" type="text" class="form-control" />
        </div>
        <div class="row panel panel-warning" *ngIf="!disabledEditing">
          <div class="col-lg">
            <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
            <div class="col-lg-8">
              <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" required dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl></p-calendar>
              <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched)" class="text-danger">La Fecha es Requerida</div>
              <mat-error *ngIf="registerFormControl.desde.errors?.desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
                No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
              </mat-error>
              <mat-error *ngIf="registerFormControl.desde.errors?.anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
                No puede ser anterior al límite de retroactividad {{gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
              </mat-error>
            </div>
          </div>
          <div class="col-lg">
            <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
            <div class="col-lg-8">
              <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" required dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl></p-calendar>
              <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)" class="text-danger">La Fecha es Requerida</div>
              <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)">
                La Fecha no puede ser menor que la Fecha Desde
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label class="col-form-label font-bold">Regla Plan Horario</label>
            <div>
              <comboTools [list]=reglasList
                          selected='reglaHt'
                          [formParent]="form"
                          [isEditing]=disabledEditing
                          filter="descripcion"
                          (SelectedChange)="onChangeReglaHorarioTrabajo($event)"
                          ph='Regla Plan Horario'></comboTools>
              <div *ngIf="registerFormControl.reglaHt.invalid && (
                  registerFormControl.reglaHt?.dirty || registerFormControl.reglaHt?.touched || submitted)" class="text-danger">
                  Regla Plan Horario es Requerida
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class=" col-form-label font-bold">Porcentaje Asignación</label>
              <input formControlName="porcentajeAsignacion" name ="selectedPorcentaje" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.porcentajeAsignacion.errors && (registerFormControl.porcentajeAsignacion?.dirty || registerFormControl.porcentajeAsignacion?.touched || submitted)}"/>
              <mat-error  class="text-danger"*ngIf="registerFormControl.porcentajeAsignacion.errors?.required && (registerFormControl.porcentajeAsignacion?.dirty || registerFormControl.porcentajeAsignacion?.touched || submitted)">
                  El Porcentaje Asignación es Requerido
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class=" col-form-label font-bold">Horas Diarias</label>
              <input formControlName="hsTrabajoDiario" name ="selectedHorasDiarias" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.hsTrabajoDiario.errors && (registerFormControl.hsTrabajoDiario?.dirty || registerFormControl.hsTrabajoDiario?.touched || submitted)}"/>
              <mat-error  class="text-danger"*ngIf="registerFormControl.hsTrabajoDiario.errors?.required && (registerFormControl.hsTrabajoDiario?.dirty || registerFormControl.hsTrabajoDiario?.touched || submitted)">
                  Las Horas Diarias son Requeridas
              </mat-error>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class=" col-form-label font-bold">Horas Semanales</label>
              <input formControlName="hsTrabSemana" name ="selectedHorasSemanales" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.hsTrabSemana.errors && (registerFormControl.hsTrabSemana?.dirty || registerFormControl.hsTrabSemana?.touched || submitted)}"/>
              <mat-error  class="text-danger"*ngIf="registerFormControl.hsTrabSemana.errors?.required && (registerFormControl.hsTrabSemana?.dirty || registerFormControl.hsTrabSemana?.touched || submitted)">
                  Las Horas Semanales son Requeridas
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class=" col-form-label font-bold">Horas Mensuales</label>
              <input formControlName="hsTrabMes" name ="selectedHorasMensuales" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.hsTrabMes.errors && (registerFormControl.hsTrabMes?.dirty || registerFormControl.hsTrabMes?.touched || submitted)}"/>
              <mat-error  class="text-danger"*ngIf="registerFormControl.hsTrabMes.errors?.required && (registerFormControl.hsTrabMes?.dirty || registerFormControl.hsTrabMes?.touched || submitted)">
                  Las Horas Mensuales son Requeridas
              </mat-error>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class=" col-form-label font-bold">Horas Anuales</label>
              <input formControlName="hsTrabAnio" name ="selectedHorasAnuales" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.hsTrabAnio.errors && (registerFormControl.hsTrabAnio?.dirty || registerFormControl.hsTrabAnio?.touched || submitted)}"/>
              <mat-error  class="text-danger"*ngIf="registerFormControl.hsTrabAnio.errors?.required && (registerFormControl.hsTrabAnio?.dirty || registerFormControl.hsTrabAnio?.touched || submitted)">
                  Las Horas Anuales son Requeridas
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class=" col-form-label font-bold">Días Hábiles Semanales</label>
              <input formControlName="diasLaboralSemana" name ="selectedDiasSemanales" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.diasLaboralSemana.errors && (registerFormControl.diasLaboralSemana?.dirty || registerFormControl.diasLaboralSemana?.touched || submitted)}"/>
              <mat-error  class="text-danger"*ngIf="registerFormControl.diasLaboralSemana.errors?.required && (registerFormControl.diasLaboralSemana?.dirty || registerFormControl.diasLaboralSemana?.touched || submitted)">
                  Los Días Hábiles Semanales son Requeridos
              </mat-error>
            </div>
          </div>
          <div class="col-md-6">
            <label class="col-form-label font-bold">Tipo Evaluación</label>
            <div>
                <comboTools
                    [list]=tipoEvaluacionList
                    selected='tipoEvaluacion'
                    [isEditing]=disabledEditing
                    [formParent]="form"
                    filter="descripcion"
                    ph='Tipo Evaluación'
                    soloDescri=true
                ></comboTools>
                <div *ngIf="registerFormControl.tipoEvaluacion.invalid && (registerFormControl.tipoEvaluacion?.dirty || registerFormControl.tipoEvaluacion?.touched || submitted)" class="text-danger">              
                    <div *ngIf="registerFormControl.tipoEvaluacion.errors.required">El campo Tipo Evaluación es requerido</div>
                </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

<div class="ibox-content m-b-sm border-bottom" *ngIf="horario == null && cargaCompleta">
  <button type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
  <div class="p-xs">
    <div class="float-left m-r-md">
      <i class="fa fa-globe text-navy mid-icon"></i>
    </div>
    <h2>Empleado sin Horas</h2>
    <span>El empleado no tiene Horario de Trabajo.</span>
  </div>
</div>
